<template>
  <div class="page">
    <Transition name="fade" mode="out-in">
      <HeaderMain
        v-if="currentComponent === 'TelegramActivation'"
        v-html="
          $t(`page.${componentState.pathToTranslate}.mainheader`, {
            value: numberState,
            msgr: 'Telegram',
          })
        "
      />
      <HeaderMain v-else-if="!!componentState?.pathToTranslate" textCenter>{{
        $t(`page.${componentState.pathToTranslate}.mainheader`, {
          value: numberState,
        })
      }}</HeaderMain>
    </Transition>
    <Transition name="fade" mode="out-in">
      <component
        :is="componentState.component"
        :number="numberState"
        :numberId="numberIdState"
        :messenger="messengerState"
        @nextStage="onNextAction"
      />
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, watchEffect, onUnmounted } from "vue";
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import TelegramActivation from "@/components/activation/TelegramActivation.vue";
import TimeExpired from "@/components/activation/TimeExpiredActivation.vue";
import GenerationCode from "@/components/activation/GenerationCodeActivation.vue";
import ScanCode from "@/components/activation/ScanCodeActivation.vue";

import useSocketActivation from "@/components/activation/api/useSocketActivation";

const { socketActivation, socketStatus, socketNumberTelegram } =
  useSocketActivation();

const router = useRouter();
const route = useRoute();
const store = useStore();

const components = {
  TelegramActivation: {
    component: TelegramActivation,
    pathToTranslate: "activation",
  },
  GenerationCode: {
    component: GenerationCode,
    pathToTranslate: "code_gen1",
  },
  TimeExpired: {
    component: TimeExpired,
  },
  ScanCode: {
    component: ScanCode,
  },
};

const currentComponent = ref("TelegramActivation");

const numberKey = ref("");

const componentState = computed(() => {
  return components[currentComponent.value];
});

const numberState = computed(() => store.state.activation.number);

const messengerState = computed(() => store.state.activation.messenger);

const numberIdState = computed(() => {
  // !!!
  if (numberKey?.value) onNextAction("generationCode");
  return numberKey?.value;
});

/**
 * Эта функция принимает параметр nextStage и выполняет различные действия на основе его значения.
 *
 * @param {string} nextStage - событие, которое передается от детей для определения последующих действий.
 * @return {void}
 */
const onNextAction = (nextStage) => {
  switch (typeof nextStage === "string" ? nextStage : nextStage.value) {
    case "oops":
      router.push({ name: "Oops" });
      break;
    case "telegramActivation":
      currentComponent.value = "TelegramActivation";
      break;
    case "generationCode":
      if (nextStage.numberKey) {
        socketActivation(nextStage.numberKey);
        numberKey.value = nextStage.numberKey;
      }
      currentComponent.value = "GenerationCode";
      break;
    case "scanCode":
      currentComponent.value = "ScanCode";
      break;
    case "timeOver":
      currentComponent.value = "TimeExpired";
      break;
    case "integration":
      router.push({ name: "Integration" });
      break;
    case "activated":
    case "successActivation":
      const number = numberState.value;
      store.commit("openDialog", {
        name: "SuccessActivationDialog",
        params: { number },
      });
      // the CRM is picked on the success page now, not before activation
      router.push({ name: "SuccessActivation", query: { messenger: "telegram" } });
      if (store.state.activation.nextStageActivation) {
        store.commit("activation/SET_NEXT_STAGE_ACTIVATION", null);
      }
      break;
    case "errorActivation":
      router.push({
        name: "SuccessActivation",
        query: { messenger: "telegram" },
      });
      break;
    case "twoFactorAuth":
      store.commit("openDialog", {
        name: "TwoFactorAuthDialog",
        params: { isSecondTry: false },
      });
      break;
    case "twoFactorAuth2":
      store.state.dialogParams.isSecondTry = true;
      break;
    default:
      // currentComponent.value = "GenerationCode";
      router.push({ name: "Oops" });
      break;
  }
};

watch(
  () => store.state.activation.qrLink,
  (newLink) => {
    if (newLink && componentState.value.pathToTranslate !== "activation") {
      onNextAction("scanCode");
    }
  }
);

watch(
  () => socketStatus.value,
  () => {
    if (socketStatus.value) {
      onNextAction(socketStatus.value);
    }
  }
);

watchEffect(() => {
  const stage = store.state.activation.nextStageActivation;
  if (!!stage) {
    onNextAction(stage);
  }
});

onMounted(() => {
  if (!store.state.activation.messenger) {
    store.commit("activation/SET_MESSENGER", "telegram");
  }
  // если номер передается параметром, а в сторе его нет, то добавляем его в стор
  if (
    !store.state.activation.number &&
    (route?.params?.number || socketNumberTelegram.value)
  ) {
    store.commit("activation/SET_NUMBER", route?.params?.number);
    console.debug("find tgSocketNumber or kill - ", socketNumberTelegram.value);
  }
  store.commit("activation/SET_IS_PUSHER", false);
});

onUnmounted(() => {
  store.commit("clearNumberData");
});
</script>

<style lang="scss" scoped>
.page {
  padding: 0 20px;

  :deep(.txt) {
    font-weight: 500;
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 850px) {
  .dialog {
    width: 100%;
  }

  .page {
    .block {
      .start {
        .block-header {
          font-size: 20px;
          line-height: 150%;
        }
      }
    }
  }
}

@media screen and (max-width: 680px) {
  .page {
    .block {
      flex-direction: column;
      padding: 15px;
      gap: 20px;

      .img1 {
        margin: auto;
        width: 45%;
        height: 50%;
      }

      .start {
        padding: 0;

        .block-header {
          font-size: 14px;
        }

        ul {
          li {
            line-height: 150%;
            font-size: 12px;
          }
        }

        .btn {
          width: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 550px) {
}

@media screen and (max-width: 450px) {
  .page .block {
    gap: 0;
  }
}

@media screen and (max-width: 400px) {
  .page {
    .block {
      .start {
        padding: 0;

        .block-header {
          font-size: 12px;
        }
      }
    }
  }
}

// @media screen and (max-width: $tablet-max-size) {
//   .modal {
//     width: 100%;
//   }
// }
</style>
